import { Injectable } from '@angular/core';
import { HttpInterceptor } from '../../node_modules/@angular/common/http';
import { HttpEvent, HttpHandler, HttpRequest, HttpResponse,HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { App } from 'ionic-angular';
import { SiteMaintenancePage } from './shared/site-maintenance/site-maintenance';



@Injectable()
export class HttpErrorInterceptor  implements HttpInterceptor {

    constructor(private app:App) {
    
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        return next.handle(request)
                  .pipe(
                    tap(event => {
                      if (event instanceof HttpResponse) {
                      }
                    }, error => {
                      // Client Side Error
                      if (error.error instanceof ErrorEvent) {} 
                      else {  // Server Side Error
                        if (error.status === undefined || error.status === 0) {
                            console.log("Received error");
                            this.app.getActiveNav().setRoot(SiteMaintenancePage);
                        }
                     }
                    
                  return throwError(error);
                    }) 
                  )
        }
}


// WEBPACK FOOTER //
// ./src/app/error-interceptor.ts